import React from "react";
import { shape, string, func, number, bool } from "prop-types";
import { connect } from "react-redux";
import FormatCurrency from "shared/components/currency/FormatCurrency";
import { Card, Button, Label, Icon } from "semantic-ui-react";
import ConfiguratorImage from "shared/components/configurator/ConfiguratorImage";
import { getConfiguratorCardInfo, getI18N } from "shared/selectors";
import { createStructuredSelector } from "reselect";
import { I18nShape } from "../../shapes";

const ConfiguratorCard = ({
  i18n,
  configuratorInfo,
  configuratorId,
  roomId,
  configuratorTitle,
  onClick
}) => {
  const { configured, total } = configuratorInfo;
  const buttonColor = configured ? "primary" : null;
  const buttonIcon = configured ? "checkmark" : "cogs";
  const buttonContent = configured
    ? i18n["buyerPortal.actions.configured"]
    : i18n["buyerPortal.actions.configure"];

  const displayAmount = total >= 0 ? total : -total;
  const displayIcon = total >= 0 ? "plus" : "minus";

  return (
    <Card data-cmd="open-configurator" onClick={onClick}>
      <Card.Content className="head">
        <Card.Header>{configuratorTitle}</Card.Header>
      </Card.Content>
      <ConfiguratorImage configuratorId={configuratorId} roomId={roomId}>
        {({ imageURL }) => {
          return (
            <Card.Content
              className="image"
              style={imageURL && { backgroundImage: `url("${imageURL}")` }}
            >
              <Label style={{ float: "right" }} className="price-tag">
                <Icon name={displayIcon} />
                <FormatCurrency amount={displayAmount} />
              </Label>
            </Card.Content>
          );
        }}
      </ConfiguratorImage>
      <Button
        fluid
        size="huge"
        basic={!configured}
        content={buttonContent}
        className={buttonColor}
        icon={buttonIcon}
      />
    </Card>
  );
};

ConfiguratorCard.propTypes = {
  i18n: I18nShape.isRequired,
  configuratorInfo: shape({
    total: number,
    configured: bool
  }).isRequired,
  configuratorId: string.isRequired,
  onClick: func.isRequired,
  roomId: string.isRequired,
  configuratorTitle: string.isRequired
};

const getConfiguratorInfo = createStructuredSelector({
  i18n: getI18N,
  configuratorInfo: getConfiguratorCardInfo
});

export default connect(getConfiguratorInfo)(ConfiguratorCard);
